import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.regexp.replace";

var hasDashes = function hasDashes(val) {
  return /-/.test(val);
};

var formatKey = function formatKey(key) {
  return hasDashes(key) ? "'".concat(key, "'") : key;
};

var formatVal = function formatVal(val) {
  return val ? '' : 'true';
};

function normalize(str, removeTrailingWhitespace) {
  var normalized = str;

  if (removeTrailingWhitespace && /\n/.test(str)) {
    normalized = normalized.replace(/[ \f\n\r\t\v]+$/, '');
  }

  normalized = normalized.replace(/^\n\r?[ \f\n\r\t\v]+/, '') // remove leading newline + space
  .replace(/[ \f\n\r\t\v]*\n\r?[ \f\n\r\t\v]*/gm, ' '); // replace newlines with spaces

  return JSON.stringify(normalized);
}

export default function jsxPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pragmaJsx = null;
  var pragmaJsxFrag = null;
  var objectAssign = options.objectAssign || 'Object.assign';
  var jsx = pragmaJsx || options.jsx || 'React.createElement';
  var jsxFragment = pragmaJsx || options.jsxFragment || 'React.Fragment';
  return {
    onComment: function onComment(_, text) {
      if (!pragmaJsx) {
        var match = /@jsx\s+([^\s]+)/.exec(text);
        if (match) pragmaJsx = match[1];
      }

      if (!pragmaJsxFrag) {
        var _match = /@jsxFrag\s+([^\s]+)/.exec(text);

        if (_match) pragmaJsxFrag = _match[1];
      }
    },
    visitor: {
      Program: function Program() {
        jsx = pragmaJsx || options.jsx || 'React.createElement';
        jsxFragment = pragmaJsx || options.jsxFragment || 'React.Fragment';
      },
      'JSXElement|JSXFragment': {
        leave: function leave(node) {
          var _this = this;

          var children = node.children.filter(function (child) {
            if (child.type !== 'JSXText') return true; // remove whitespace-only literals, unless on a single line

            return /[^ \f\n\r\t\v]/.test(child.raw) || !/\n/.test(child.raw);
          });

          if (children.length) {
            var c = (node.openingElement || node.openingFragment).end;
            children.forEach(function (child, i) {
              if (child.type === 'JSXExpressionContainer' && child.expression.type === 'JSXEmptyExpression') {// empty block is a no op
              } else {
                var tail = _this.original[c] === '\n' && child.type !== 'JSXText' ? '' : ' ';

                _this.appendLeft(c, ",".concat(tail));
              }

              if (child.type === 'JSXText') {
                var str = normalize(child.value, i === children.length - 1);

                _this.overwrite(child.start, child.end, str);
              }

              c = child.end;
            });
          }
        }
      },
      JSXOpeningElement: {
        leave: function leave(node) {
          this.overwrite(node.start, node.name.start, "".concat(jsx, "("));
          var hostType = node.name.type === 'JSXIdentifier' && node.name.name[0] === node.name.name[0].toLowerCase();
          if (hostType) this.prependRight(node.name.start, "'");
          var len = node.attributes.length;
          var c = node.name.end;

          if (len) {
            var i;
            var hasSpread = false;

            for (i = 0; i < len; i += 1) {
              if (node.attributes[i].type === 'JSXSpreadAttribute') {
                hasSpread = true;
                break;
              }
            }

            c = node.attributes[0].end;

            for (i = 0; i < len; i += 1) {
              var attr = node.attributes[i];

              if (i > 0) {
                if (attr.start === c) this.prependRight(c, ', ');else this.overwrite(c, attr.start, ', ');
              }

              if (hasSpread && attr.type !== 'JSXSpreadAttribute') {
                var lastAttr = node.attributes[i - 1];
                var nextAttr = node.attributes[i + 1];

                if (!lastAttr || lastAttr.type === 'JSXSpreadAttribute') {
                  this.prependRight(attr.start, '{ ');
                }

                if (!nextAttr || nextAttr.type === 'JSXSpreadAttribute') {
                  this.appendLeft(attr.end, ' }');
                }
              }

              c = attr.end;
            }

            var after;
            var before;

            if (hasSpread) {
              if (len === 1) {
                before = hostType ? "'," : ',';
              } else {
                before = hostType ? "', ".concat(objectAssign, "({},") : ", ".concat(objectAssign, "({},");
                after = ')';
              }
            } else {
              before = hostType ? "', {" : ', {';
              after = ' }';
            }

            this.prependRight(node.name.end, before);

            if (after) {
              this.appendLeft(node.attributes[len - 1].end, after);
            }
          } else {
            this.appendLeft(node.name.end, hostType ? "', null" : ", null");
            c = node.name.end;
          }

          if (node.selfClosing) {
            this.overwrite(c, node.end, ")");
          } else {
            this.remove(c, node.end);
          }
        }
      },
      JSXClosingElement: {
        leave: function leave(node) {
          this.overwrite(node.start, node.end, ')');
        }
      },
      JSXAttribute: function JSXAttribute(node) {
        var _node$name = node.name,
            start = _node$name.start,
            name = _node$name.name; // Overwrite equals sign if value is present.

        var end = node.value ? node.value.start : node.name.end;
        this.overwrite(start, end, "".concat(formatKey(name), ": ").concat(formatVal(node.value)));
      },
      JSXExpressionContainer: function JSXExpressionContainer(node) {
        this.remove(node.start, node.expression.start);
        this.remove(node.expression.end, node.end);
      },
      JSXOpeningFragment: function JSXOpeningFragment(node) {
        this.overwrite(node.start, node.end, "".concat(jsx, "(").concat(jsxFragment, ", null"));
      },
      JSXClosingFragment: function JSXClosingFragment(node) {
        this.overwrite(node.start, node.end, ')');
      },
      JSXSpreadAttribute: function JSXSpreadAttribute(node) {
        this.remove(node.start, node.argument.start);
        this.remove(node.argument.end, node.end);
      }
    }
  };
}